import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { PII_MASK_CSS_CLASS } from '../../../../constants';

import styles from './UserMenu.module.css';

export interface UserMenuButtonProps {
  dataHcName: string;
  icon: ReactNode;
  label: ReactNode;
  noCapture?: boolean;
  description?: ReactNode;
  className?: string;
  onClick?: VoidFunction;
  // Wraps the li with a NavLink
  navigateTo?: string;
}

export type UserMenuButtonGroupsProps = UserMenuButtonProps[][];

export const UserMenuButton = ({
  dataHcName,
  className,
  icon,
  label,
  noCapture = false,
  description,
  navigateTo,
  onClick,
}: UserMenuButtonProps) => {
  const button = (
    <li
      data-hc-name={dataHcName}
      className={classNames(styles.Button, className, {
        [PII_MASK_CSS_CLASS]: noCapture,
      })}
      onClick={onClick}
    >
      <div
        className={styles.ButtonIcon}
        data-hc-name={`${dataHcName}-icon-container`}
      >
        {icon}
      </div>
      <div className={styles.ButtonContent}>
        <div
          className={styles.ButtonLabel}
          data-hc-name={`${dataHcName}-label`}
        >
          {label}
        </div>
        {description && (
          <div
            className={styles.ButtonDescription}
            data-hc-name={`${dataHcName}-description`}
          >
            {description}
          </div>
        )}
      </div>
    </li>
  );
  if (navigateTo) {
    return (
      <Link data-hc-name={`${dataHcName}-link`} to={navigateTo}>
        {button}
      </Link>
    );
  } else {
    return button;
  }
};
